import { styled } from '@mui/material';
import { ComponentPropsWithoutRef } from 'react';
import { Technology } from 'utils/products';

type TProps = ComponentPropsWithoutRef<typeof StyledImage> & {
  version?: 'full' | 'icon';
};

const StyledImage = styled('img')({});

export const TechnologyLogo = ({ version = 'full', ...props }: TProps) => {
  const technology = Technology.getProperties();

  const src = version === 'full' ? technology?.img : technology?.icon;

  if (!src) {
    return null;
  }

  return <StyledImage src={src} alt={technology?.label} {...props} />;
};
